import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

/**
 * 'supplier-consultation': '供应商咨询',
 */
const route: AppRouteModule = {
  path: '/supplier-consultation',
  name: 'SupplierConsultation',
  component: LAYOUT,
  redirect: '/supplier-consultation/business-consulting',
  meta: {
    icon: 'mingcute:certificate-line',
    title: t('routes.supplier-consultation.main'),
    orderNo: 1100,
    roles: [20222397],
  },
  children: [
    /**
     * business-consulting: '业务咨询',
     */
    {
      path: 'business-consulting',
      name: 'BusinessConsulting',
      component: () => import('/@/views/supplier-consultation/business-consulting/index.vue'),
      meta: {
        title: t('routes.supplier-consultation.business-consulting'),
        roles: [20222398],
      },
    },
  ],
};

export default route;
